import { useCallback } from 'react'

import { Post } from '@/features/help-center/types/post'

import { shouldSendOnce } from './shouldSendOnce'
import { useAnalytics } from './useAnalytics'

export function useHelpAnalytics() {
  const { track } = useAnalytics()

  const trackHelpPostViewed = useCallback(
    (post: Post) => {
      if (shouldSendOnce('help_post_viewed', post.id, 30 * 60 * 1000)) {
        track.event('help_post_viewed', {
          post_id: post.id,
          post_name: post.name.slice(0, 50),
          context_route: window.location.pathname
        })
      }
    },
    [track]
  )

  const trackContentSearched = useCallback(
    (query: string, resultsCount: number) => {
      track.searched(query, resultsCount, 'help')
    },
    [track]
  )

  return {
    trackHelpPostViewed,
    trackContentSearched
  }
}
